import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterOutlet, RouterLink, ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { settings } from 'environments/environment';
import { SubscriptionsApiService } from 'shared/services/api/subscriptions.api.service';
import { APIResponse } from 'fakturnia-shared';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, MatButtonModule, MatIconModule],
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  panels: any[] = [];
  selectedPanel: string = 'pulpit';
  pendingOrdersCount = 0;

  public version = settings.version;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _route: ActivatedRoute,
    private _subscriptionsApi: SubscriptionsApiService,
  ) {
    this._buildPanels();
    this._loadPendingOrdersCount();
  }

  private _buildPanels() {
    this.panels = [];

    this.panels.push(
      { id: 'pulpit', icon: 'tabler_outline:dashboard', title: 'Pulpit', description: 'Panel administracyjny' },
    );

    this.panels.push(
      { id: 'users', icon: 'tabler_outline:users', title: 'Użytkownicy', description: 'Zarządzaj użytkownikami' }
    );

    this.panels.push(
      { id: 'announcements', icon: 'tabler_outline:speakerphone', title: 'Ogłoszenia systemowe', description: 'Poinformuj użytkowników' }
    );

    this.panels.push(
      { id: 'backup', icon: 'tabler_outline:database-export', title: 'Backup', description: 'Kopia zapasowa' }
    );

    this.panels.push(
      { id: 'ksef', icon: 'tabler_outline:cloud-upload', title: 'Monitoring KSeF', description: 'Wysyłki batch, błędy, logi' }
    );

    this.panels.push(
      { id: 'rest-api', icon: 'tabler_outline:api', title: 'REST API', description: 'Konta API, webhooki, logi, limity' }
    );

    this.panels.push(
      { id: 'subscriptions', icon: 'tabler_outline:credit-card', title: 'Subskrypcje', description: 'Zarządzaj planami', badge: () => this.pendingOrdersCount, badgeClass: 'bg-amber-500' }
    );

    this.panels.push(
      { id: 'campaigns', icon: 'tabler_outline:mail', title: 'Kampanie', description: 'Newsletter i wysyłki' }
    );

    this.panels.push(
      { id: 'notifications', icon: 'tabler_outline:bell-ringing', title: 'Powiadomienia', description: 'Wyślij powiadomienie push' }
    );

    this.panels.push(
      { id: 'statistics', icon: 'tabler_outline:chart-bar', title: 'Statystyki', description: 'Statystyki przewodnika' }
    );
  }

  private _loadPendingOrdersCount() {
    this._subscriptionsApi.getOrders().pipe(take(1)).subscribe({
      next: (response: APIResponse) => {
        if (response.success && response.data) {
          this.pendingOrdersCount = response.data.filter((o: any) => o.status === 'pending').length;
          this._changeDetectorRef.markForCheck();
        }
      }
    });
  }

  ngOnInit(): void {
    this._buildPanels();
    this.selectedPanel = this._route?.firstChild?.snapshot.url[0]?.path || 'pulpit';
    this._changeDetectorRef.markForCheck();
  }

  goToPanel(panel: string): void {
    this.selectedPanel = panel;
  }

  getPanelInfo(id: string): any {
    const panel = this.panels.find(p => p.id === id);
    if (!panel) return { title: '' };
    return panel;
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
